class GzWarrantyLifeModal extends GzCosmeticModal {
  init() {
    this.storeTabs();
    this.renderModal();
    this.addEventListeners();
  }

  storeTabs() {
    this.tabs = [];
    const tabElements = this.querySelectorAll('[data-tab-id]');
    tabElements.forEach(tab => {
      this.tabs.push({
        id: tab.getAttribute('data-tab-id'),
        content: tab.outerHTML
      });
    });
  }

  openModal(tabId = '1', triggerElement = null) {
    this.lastFocusedElement = triggerElement || document.activeElement;
    document.body.style.overflow = 'hidden';
    const modalTitle = this.modal.querySelector('#gz-warrantylife-modal-title');
    const modalTitleObj= Object.keys(JSON.parse(this.getAttribute('gz-data-modal-title')));
    modalTitle.textContent = Object.values(modalTitleObj)[0];
    this.modalBackdrop.classList.add('show');
    this.modal.classList.add('show');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modalOpen = true;
    const conditionInputValues = Object.keys(JSON.parse(this.getAttribute('gz-data-cosmetic-modal-descriptions')));
    const tabIndex = parseInt(tabId) - 1;
    if (tabIndex >= 0 && tabIndex < conditionInputValues.length) {
      this.updateCurrentCondition(conditionInputValues[tabIndex]);
    }
    // Focus trap (overrides base openModal so must be wired here explicitly;
    // closeModal is inherited from GzCosmeticModal and handles cleanup)
    this._boundTrapFocus = this._trapFocusHandler.bind(this);
    document.addEventListener('keydown', this._boundTrapFocus);
    const focusable = this._getFocusableElements();
    if (focusable.length) focusable[0].focus();
  }

  renderModal() {
    this.modalBackdrop = document.createElement('div');
    this.modalBackdrop.classList.add('gz-modal-backdrop');
    this.modal = document.createElement('div');
    this.modal.classList.add('gz-modal');
    this.modal.classList.add('warranty')
    const defaultTab = this.tabs.find(tab => tab.id === '1');
    const initialContent = defaultTab ? defaultTab.content : '';

    const modalContent = `
      <div class="gz-modal-content">
        <div class="gz-modal-header">
          <h2 id="gz-warrantylife-modal-title">Protect your device</h2>
        </div>
          <button type="button" class="gz-modal-close close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <path d="M15.1719 2.42188L9.54688 8L15.125 13.5781L15.9219 14.375L14.375 15.9688L13.5781 15.1719L8 9.59375L2.42188 15.1719L1.625 15.9688L0.03125 14.375L0.828125 13.5781L6.40625 8L0.828125 2.42188L0.03125 1.625L1.625 0.03125L2.42188 0.828125L8 6.45312L13.5781 0.875L14.375 0.078125L15.9688 1.625L15.1719 2.42188Z" fill="#193154"/>
            </svg>
          </button>
        <div class="gz-modal-button-content"></div>
        <div class="gz-modal-main-content">
          <div class="gz-modal-description">${initialContent}</div>
        </div>
      </div>
    `;
    this.modal.innerHTML = modalContent;

    // Set dialog ARIA attributes once at creation
    this.modal.setAttribute('role', 'dialog');
    this.modal.setAttribute('aria-modal', 'true');
    this.modal.setAttribute('aria-labelledby', 'gz-warrantylife-modal-title');
    this.modal.setAttribute('aria-hidden', 'true');

    document.body.appendChild(this.modalBackdrop);
    document.body.appendChild(this.modal);
    this.renderModalButtons();
    this.closeButton = this.modal.querySelector('.close');
    this.closeButton.addEventListener('click', () => this.closeModal());
    this.modalBackdrop.addEventListener('click', () => this.closeModal());
  }

  renderModalButtons() {
    const conditionInputValues = Object.keys(JSON.parse(this.getAttribute('gz-data-cosmetic-modal-descriptions'))).map(
      input => input,
    );

    if (conditionInputValues.length > 1) {
      conditionInputValues.forEach((condition, index) => {
        const button = document.createElement('button');
        button.textContent = condition;
        button.classList.add('gz-modal-button-secondary');
        if (index === 0) {
          button.classList.add('active');
        }
        button.addEventListener('click', () => this.updateCurrentCondition(condition));
        this.modal.querySelector('.gz-modal-button-content').appendChild(button);
      });
    }
  }

  updateCurrentCondition(condition) {
    const modalBtns = document.querySelectorAll('button.gz-modal-button-secondary');
    modalBtns.forEach(button =>
      button.innerHTML === condition ? button.classList.add('active') : button.classList.remove('active'),
    );

    this.activeTab = condition;

    const conditionInputValues = Object.keys(JSON.parse(this.getAttribute('gz-data-cosmetic-modal-descriptions')));
    const conditionIndex = conditionInputValues.indexOf(condition);
    const tabId = (conditionIndex + 1).toString();
    const correspondingTab = this.tabs.find(tab => tab.id === tabId);
    if (correspondingTab) {
      const modalDescription = this.modal.querySelector('.gz-modal-description');
      modalDescription.innerHTML = correspondingTab.content;
    }
  }

  renderConditionElement() {
    const inputs = this.conditionFieldSet.querySelectorAll('input');
    let conditionValue = '';
    inputs.forEach(input => {
      if (input.checked) {
        conditionValue = input.value;
      }
    });

    const template = `
     <span class="modal-trigger">Learn more</span>
    `;

    this.appendChild(document.createElement('div'));
    this.innerHTML = template;
  }

  addEventListeners() {
    const triggers = JSON.parse(this.dataset.triggers) || ['warranty-trigger', 'device-protection-trigger'];

    this.handleExternalTriggers = (e) => {
      if (e.target.closest('.modal-trigger')) {
        this.openModal('1', e.target.closest('.modal-trigger'));
      } else if (triggers[0] && e.target.closest(`.${triggers[0]}`)) {
        this.openModal('1', e.target.closest(`.${triggers[0]}`));
      } else if (triggers[1] && e.target.closest(`.${triggers[1]}`)) {
        this.openModal('2', e.target.closest(`.${triggers[1]}`));
      }
    };

    document.addEventListener('click', this.handleExternalTriggers);
  }

  disconnectedCallback() {
    if (this.handleExternalTriggers) {
      document.removeEventListener('click', this.handleExternalTriggers);
    }
  }
}

customElements.define('gz-warranty-life-modal', GzWarrantyLifeModal);